import React, { useState } from 'react';
import { Collapse } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import sh from 'components/shared.module.css';
import PreferencePriorities from './PreferencePriorities';
import InterestingObjects from 'components/Panels/InterestingObjects/InterestingObjects';
import ItemsContainer from './ItemsContainer';
import s from './selections.module.css';

const DropdownBox = ({ title, children, collapsed }) => {
  const [isCollapsed, toggleCollapse] = useState(collapsed);
  const icon = isCollapsed ? 'eye-slash' : 'eye';
  return (
    <>
      <div
        className={s.header}
        onClick={() => toggleCollapse(!isCollapsed)}
      >
        <div className='d-flex justify-content-between mx-1'>
          <div className={`${(isCollapsed) ? sh.titleSelected : ''}`}>{title}</div>
          <FontAwesomeIcon icon={['far', icon]} color='#404040' style={{ marginTop: 2 }} />
        </div>
      </div>
      <Collapse in={isCollapsed}>
        {children}
      </Collapse>
    </>
  );
};

const Selections = () => {
  return (
    <div className={sh.sidePanelCont}>
      <div className={sh.normalize}>
        <div className={sh.headerCategory}><span className='ml-1'>Selections</span></div>
        <div className={sh.fixSidePanelScrollbar}>
          <DropdownBox title='Preference Priorities' collapsed>
            <div>
              <PreferencePriorities />
            </div>
          </DropdownBox>
          <DropdownBox title='Preference Cycles'>
            <div>
              <ItemsContainer bgColor='#c3c3c3' />
            </div>
          </DropdownBox>
          <DropdownBox title='Object Restriction History'>
            <div>
              <ItemsContainer bgColor='#ffb7b7' />
            </div>
          </DropdownBox>
          <DropdownBox title='Preference Actions History'>
            <div>
              <ItemsContainer bgColor='#dddcff' />
            </div>
          </DropdownBox>
          <DropdownBox title='Interesting Objects'>
            <div>
              <InterestingObjects />
            </div>
          </DropdownBox>
        </div>
      </div>
    </div>
  );
};

export default Selections;
